import React from 'react';
import { InlineBanner, Box } from '@cad-arc';
import { useIntegratedForm } from '../use-integrated-form';
import { get } from 'lodash';

type InlineBannerProps = React.ComponentProps<typeof InlineBanner>;

type Props = {
    status?: InlineBannerProps['status'];
    title?: string;
};

export function FormSavingErrorBanner(props: Props): React.ReactElement {
    const integratedForm = useIntegratedForm();
    const errorMessage =
        props.title ??
        get(integratedForm, 'mutation.error.response.data.error') ??
        'An error occurred while saving';

    return integratedForm.mutation.isError ? (
        <Box mb="1" w="100%">
            <InlineBanner status={props.status ?? 'error'} title={errorMessage} />
        </Box>
    ) : (
        <></>
    );
}
